import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS, setNumPendingTransferees, setPageTitle, showToast } from '../layout/layout.actions';
import {
  cancelAuthorization, FAILURE_TYPES,
  getAllCountries,
  getAllEnumerations,
  getAllProvinces,
  getApprovalPendingAuthorizations,
  getPendingAuthorization,
  getTempAuthFiles,
  getTempFilesByMonth,
  getTempFilesByProgram,
  getClientInformation
} from './authorizations.actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { PureComponent } from 'react';
 
import { getSelectedClientInformation, getUserName, isClientSelected } from '../../utilities/authUtils';
import ApprovalPendingAuthorizations from './approvalPendingAuthorizations.component';
import AuthorizationChart from './authorizationChart.component';
import AuthorizationEditCreate from './authorizationEditCreate/authorizationEditCreate.component';
import PendingAuthorizations from './pendingAuthorizations.component';
import SubmittedAuthorizations from './submittedAuthorizations.component';
 
import { userHasPermission, isSamsungClient } from '../../utilities/authUtils';
 
import { Box } from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import TableauReportWrapper from 'modules/reporting/tableauReportWrapper.component';
 
class AuthorizationsContainer extends PureComponent {
  constructor(props) {
    super(props);
 
    this.state = {
      selectedAuthorization: null,
    };
 
    this.handleEditAuthorization = this.handleEditAuthorization.bind(this);
    this.handleNewAuthorization = this.handleNewAuthorization.bind(this);
    this.getPendingAuthorization = this.getPendingAuthorization.bind(this);
    this.handleCancelAuthorization = this.handleCancelAuthorization.bind(this);
  }
 
  async componentDidMount() {
    this.props.setPageTitle('My Authorizations');
 
    let actionsList = [
      // this.props.getApprovalPendingAuthorizations(),
      this.props.getTempAuthFiles(getSelectedClientInformation().id),
      this.props.getAllEnumerations(),
      this.props.getAllCountries(),
      this.props.getAllProvinces(),
      this.props.getClientInformation(parseInt(getSelectedClientInformation().id)),
    ];
 
    if (getSelectedClientInformation().id !== '238') {
      actionsList.push(this.props.getTempFilesByProgram(getSelectedClientInformation().id));
      actionsList.push(this.props.getTempFilesByMonth(getSelectedClientInformation().id));
    }
 
    const actions = await Promise.all(actionsList);
    if (actions.some(action => FAILURE_TYPES.includes(action.type))) {
      this.props.showToast('Failed to load some of the authorizations', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
    this.props.setNumPendingTransferees(this.props.pendingAuthorizations.length);
  }
 
  getPendingAuthorization(id) {
    return this.props.getPendingAuthorization(id);
  }
 
  handleEditAuthorization(id) {
    this.props.history.push(`/authorizations/${  id}`);
  }
 
  handleNewAuthorization() {
    this.props.history.push('/authorizations/new');
  }
 
  async handleCancelAuthorization(id) {
    let response = await this.props.cancelAuthorization(id);
    if (response.type === 'CANCEL_AUTHORIZATION_SUCCESS') {
      this.props.showToast('Successfully canceled authorization.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      await this.props.getTempAuthFiles(getSelectedClientInformation().id);
      this.props.setNumPendingTransferees(this.props.pendingAuthorizations.length);
    } else {
      this.props.showToast('Failed to cancel authorization. Please check your connection and try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
  }
 
  render() {
    let {
      pendingAuthorizations,
      pendingApprovalAuthorizations,
      clientDivisions,
      authCountsByProgram,
      authCountsByMonth,
      submittedAuths,
      isLoading,
      isLoadingApprovalAuthorization,
      isLoadingSubmittedAuths,
      countryEnums,
      provinceEnums,
      clientInfo,
    } = this.props;
    let { selectedAuthorization } = this.state;

    // TODO: check for user permission to modify authorizations
    // const isReadOnly = !userHasPermission('create:authorizations');
    const isReadOnly = false;

    if (!submittedAuths) {
      submittedAuths = [];
    }
 
    const chartData = {
      authCountsByProgram,
      authCountsByMonth,
    };
 
    const tableauReportChart = 'views/AuthorizationsOnly-Samsung{{env}}/Dashboard2';

    let hasConfidentialFileAccess = false;
    if(this.props.clientInfo && this.props.clientInfo.clientContacts && this.props.clientInfo.clientContacts.length > 0) {
      let currentToken = getUserName();
      let currentUser = this.props.clientInfo.clientContacts.find((contact) => contact.contact.auth0UserId === currentToken);
      if(currentUser) {
        hasConfidentialFileAccess = currentUser.contact.hasConfidentialFileAccess;
      }
    }
    //TODO - Revert until cc integration is complete
    const isAuthorizer = true;
    const allowAddAuthorization = isClientSelected() && isAuthorizer;
    return (
      <>
          <div style={{ padding: "2rem" }}>
            {selectedAuthorization && (
              <AuthorizationEditCreate
                selectedAuthorization={selectedAuthorization}
                countryEnums={countryEnums}
                provinceEnums={provinceEnums}
                clientInfo={clientInfo}
                hasConfidentialFileAccess={hasConfidentialFileAccess}
              />
            )}
            {!selectedAuthorization && (
              <div>
                {isSamsungClient() === true && (
                  <Paper style={{ padding: "0rem 0rem", marginBottom: "1rem" }}>
                    <Box padding="2rem 0rem" height="100%" width="100%">
                      <TableauReportWrapper reportPath={tableauReportChart} isSamsung={true} />
                    </Box>
                  </Paper>
                )}
 
                {!isReadOnly && (
                  <div style={{ marginBottom: "1rem" }}>
                    <PendingAuthorizations
                      isLoading={isLoading}
                      rows={pendingAuthorizations}
                      allowAddNew={allowAddAuthorization}
                      isReadOnly={isReadOnly}
                      hasConfidentialFileAccess={hasConfidentialFileAccess}
                      handleEditAuthorization={this.handleEditAuthorization}
                      handleNewAuthorization={this.handleNewAuthorization}
                      handleCancelAuthorization={this.handleCancelAuthorization}
                    />
                  </div>
                )}
                {userHasPermission(
                  "authorization:requiresApproval",
                  clientDivisions
                ) && (
                  <ApprovalPendingAuthorizations
                    isLoading={isLoadingApprovalAuthorization}
                    rows={pendingApprovalAuthorizations}
                    allowAddNew={allowAddAuthorization}
                    isReadOnly={isReadOnly}
                    handleEditAuthorization={this.handleEditAuthorization}
                    handleNewAuthorization={this.handleNewAuthorization}
                    handleCancelAuthorization={this.handleCancelAuthorization}
                  />
                )}
 
                {(getSelectedClientInformation().id !== "238" && !isSamsungClient()) && (
                  <div style={{ marginBottom: "1rem" }}>
                    <AuthorizationChart chartData={chartData} />
                  </div>
                )}
 
                <div style={{ marginBottom: "1rem" }}>
                  <SubmittedAuthorizations
                    isLoading={isLoadingSubmittedAuths}
                    rows={submittedAuths}
                    handleViewAuthorization={this.handleEditAuthorization}
                    countryEnums={countryEnums}
                    provinceEnums={provinceEnums}
                    hasConfidentialFileAccess={hasConfidentialFileAccess}
                  />
                </div>
              </div>
            )}
          </div>
      </>
    );
  }
}
 
const mapStateToProps = (state) => {
  return {
    pendingAuthorizations: state.authorizations.get('pendingAuthorizations'),
    pendingApprovalAuthorizations: state.authorizations.get('pendingApprovalAuthorizations'),
    pendingAuthorization: state.authorizations.get('pendingAuthorization'),
    authCountsByProgram: state.authorizations.get('authCountsByProgram'),
    authCountsByMonth: state.authorizations.get('authCountsByMonth'),
    submittedAuths: state.authorizations.get('submittedAuths'),
    clientDivisions: state.layout.get('clientDivisions'),
    isLoading: state.authorizations.get('isLoading'),
    isLoadingApprovalAuthorization: state.authorizations.get('isLoadingApprovalAuthorization'),
    isLoadingSubmittedAuths: state.authorizations.get('isLoadingSubmittedAuths'),
    allEnums: state.authorizations.get('allEnums'),
    countryEnums: state.authorizations.get('countryEnums'),
    provinceEnums: state.authorizations.get('provinceEnums'),
    clientInfo: state.authorizations.get('clientInfo'),
    userContact: state.layout.get('userContact'),
  };
};
 
export default withRouter(connect(mapStateToProps, {
  setPageTitle,
  getApprovalPendingAuthorizations,
  getPendingAuthorization,
  cancelAuthorization,
  showToast,
  setNumPendingTransferees,
  getTempAuthFiles,
  getTempFilesByMonth,
  getTempFilesByProgram,
  getAllEnumerations,
  getAllCountries,
  getAllProvinces,
  getClientInformation
})(AuthorizationsContainer));